import { COUNTRY_EXCEPTIONS } from '@/constants/web-locales.constant';
import { WebLocale } from '@/enums/web-locale';
import { getAxios } from '@/helpers/axios-helper';

export type IpCheckResponse = {
	ip?: string;
	country: string;
	asn?: number;
	provider?: string;
};
export type IpCheck = IpCheckResponse & { webLocale: WebLocale };

/**
 * checkIp detect location of user with our checkip service
 *
 * @throws Error configuration missing
 * @throws Error GET call fail (Adblocker)
 */
export async function checkIp(): Promise<IpCheck> {
	const url = JW_CONFIG.CHECKIP_URL;
	if (!url) {
		throw new Error('[JW_CONFIG] CHECKIP_URL configuration is missing.');
	}

	const response = await getAxios().get<IpCheckResponse>(url, {
		timeout: 3000,
	});

	const webLocale =
		response.data.country in COUNTRY_EXCEPTIONS
			? COUNTRY_EXCEPTIONS[response.data.country]
			: (response.data.country.toLowerCase() as WebLocale);
	return {
		...response.data,
		webLocale,
	};
}
